// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_clGHc {
	display: inline-flex;
	flex-direction: column;
	gap: 6px;
	width: 100%;
	.header_E6dxw {
		background: var(--white-color);
		border: 1px solid var(--border-color);
		display: inline-flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		padding: 8px;
		.title_okJFn {
			display: inline-flex;
			flex-direction: column;
			gap: 2px;
			p {
				font-size: 18px;
				font-weight: 600;
			}
			a {
				font-size: 14px;
				text-decoration: underline;
				color: var(--text-color-secondary);
				line-height: 7px;
				margin-bottom: 8px;
			}
		}
		.share_Ahg_s {
			display: inline-flex;
			align-items: center;
			background: var(--_10a37f-background);
			color: var(--_16c0982e-background);
			font-size: 16px;
			font-weight: 600;
			padding: 4px 10px;
			border-radius: 6px;
			gap: 8px;
			svg {
				color: var(--_16c0982e-background);
				width: 14px;
			}
		}
	}
	.subHeader_J0m7k {
		display: inline-flex;
		gap: 40px;
		align-items: flex-start;
		padding: 4px 10px 8px;
		.left_Av_1k {
			min-width: 310px;
			width: 310px;
			display: inline-flex;
			gap: 8px;
			> div {
				min-width: 40px;
				min-height: 40px;
				width: 40px;
				height: 40px;
				border-radius: 50%;
				background: var(--_10a37f-background);
				color: var(--_16c0982e-background);
				align-items: center;
				justify-content: center;
				display: inline-flex;
				font-size: 23px;
				font-weight: 500;
				line-height: 0px;
			}
			p {
				font-size: 26px;
				font-weight: 600;
				color: var(--_3c3a3a-color);
			}
		}
		.right_Apj4d {
			width: 600px;
			display: inline-flex;
			flex-direction: column;
			align-items: flex-start;
			b {
				font-size: 22px;
				font-weight: 500;
			}
			ul {
				display: inline-flex;
				flex-direction: column;
				gap: 2px;
				li {
					display: inline-flex;
					align-items: center;
					gap: 4px;
					svg {
						width: 20px;
						height: 20px;
						min-width: 20px;
						min-height: 20px;
						color: var(--_10a37f-background);
					}
				}
			}
		}
	}
	.calendar_sy1QJ {
		display: inline-flex;
		align-items: flex-start;
		gap: 10px;
		padding: 10px;
		border-top: 1px solid var(--border-color);
		background: var(--white-color);
		.left_Av_1k {
			min-width: 280px;
			width: 280px;
			display: inline-flex;
			flex-direction: column;
			gap: 6px;
			.title_okJFn {
				font-size: 26px;
			}
			.date_zYe3g {
				width: 100%;
				display: inline-flex;
				align-items: center;
				gap: 2px;
				justify-content: space-between;
				> div {
					display: inline-flex;
					align-items: center;
					gap: 4px;
					button {
						min-width: 20px;
						min-height: 20px;
						border-radius: 4px;
						border: 1px solid var(--border-color);
						display: inline-flex;
						align-items: center;
						justify-content: center;
						svg {
							width: 12px;
						}
					}
				}
			}
		}
	}
}
.miniCalendar_mTerZ {
	width: 100%;
	background: transparent;
	border-radius: 10px;
	padding: 4px;
	padding-bottom: 6px;
	table {
		width: 100%;
		td,
		th {
			width: calc(100vh / 7);
			text-align: center;
			font-size: 12px;
			height: 40px;
		}
	}
}
.liText_AFdHM {
	font-size: 12px;
}

.tableCalendar_j0uT2 {
	border-radius: 8px;
	z-index: 5000;
	width: 100%;
	background-color: var(--f5-background);
	height: calc(100vh - 112px);
	overflow: scroll;
	table {
		width: 100%;

		th {
			text-align: left;
			min-height: 100px;
		}

		td {
			border: 1px solid var(--border-color);
			text-align: center;
			background-color: var(--white-color);

			&.active_YlASi {
				background: var(--_16c09821-background);
				border-color: var(--_16c098-color);
				color: var(--_16c098-color);
				cursor: pointer;

				&:hover {
					background: var(--e6fff9-background);
					border-color: var(--_16c09821-background);
					color: var(--_16c09821-background);
				}
			}
		}

		&.calendarDay_WLldi {
			min-width: 750px;
			th,
			td {
				width: 7%;
				min-height: 40px;
				height: 40px;
			}

			th:nth-child(1),
			td:nth-child(1) {
				position: relative;
				min-width: 70px;
				width: 70px;
				background: var(--f5-background);
				color: var(--_10a37f-background);
				border-color: var(--border-color);
				border-left: none !important;
				border-right: none !important;
				padding: 2px 5px;
				font-size: 11px;
				font-weight: 500;
				text-align: right;
			}

			th {
				background: var(--_16c0982e-background);
				color: var(--_10a37f-background);
				border-color: var(--_16c0982e-background);
				padding: 2px 9px;
				font-size: 15px;
				font-weight: 600;
			}

			th:nth-child(1) {
				background: var(--f5-background);
			}

			th:nth-child(2),
			td:nth-child(2) {
				width: 100%;
			}
		}

		&.calendarWeek__LoKs {
			min-width: 750px;
			th,
			td {
				width: 11vw !important;
				min-height: 40px;
				height: 40px;
			}
			tbody {
				background-color: var(--f5-background);
			}
			th:nth-child(1),
			td:nth-child(1) {
				position: relative;
				min-width: 70px;
				width: 70px !important;
				background: var(--f5-background);
				color: var(--_10a37f-background);
				border-color: var(--border-color);
				border-left: none !important;
				border-right: none !important;
				padding: 2px 5px;
				font-size: 11px;
				font-weight: 500;
				text-align: right;
			}

			th {
				background: var(--_16c0982e-background);
				color: var(--_10a37f-background);
				border-color: var(--_16c0982e-background);
				padding: 2px 9px;
				font-size: 15px;
				font-weight: 600;
			}

			th:nth-child(1) {
				background: var(--f5-background);
			}
		}

		&.calendarMonth_dSM0c {
			min-width: 750px;
			th,
			td {
				width: calc(100% / 7);
			}

			th {
				text-align: center;
				border-bottom: none;
				color: var(--_10a37f-background);
				border-color: var(--_16c0982e-background);
				font-size: 11px;
				padding-top: 2px;
			}

			td {
				border-top: none;
				height: calc((100vh / 5) - 26px);

				.day_EQoXh {
					display: inline-flex;
					flex-direction: column;
					position: relative;
					align-items: center;
					justify-content: flex-start;
					height: 100%;
					max-height: 175px;
					width: 100%;

					b {
						font-size: 14px;
						font-weight: 800;
					}

					ul {
						margin-top: 4px;
						display: inline-flex;
						flex-direction: column;

						li {
							display: block;
							display: inline-flex;
							flex-direction: column;
							align-items: center;
							gap: 4px;

							.date_zYe3g {
								display: inline-flex;
								align-items: center;
								gap: 4px;

								.dot_Pfcwl {
									min-width: 8px;
									min-height: 8px;
									border-radius: 50%;
									background: var(--_16c0982e-background);

									&.active_YlASi {
										background: var(--_10a37f-background);
									}
								}

								span {
									font-size: 11px;
									font-weight: 500;
								}
							}

							.info_QQsqq {
								width: 80px;
								font-size: 10px;
								font-weight: 600;
								background: var(--white-color);
								border-radius: 6px;
								padding: 2px 4px;
								text-wrap: nowrap;
								cursor: pointer;
								&::-webkit-scrollbar {
									display: none;
								}
								&:hover {
									background: var(--f5-background);
								}

								span {
									font-size: 10px;
									font-weight: 400;
								}

								b {
									width: 100px;
									font-size: 14px;
									font-weight: 600;
								}
							}
						}
					}
				}
			}
		}

		&.schedule_WLaWf {
			min-width: 750px;
			th {
				border-color: var(--_16c0982e-background);
				background: var(--_16c0982e-background);
				color: var(--_10a37f-background);
				font-size: 14px;
				font-weight: 500;
				padding: 4px 10px;
				font-size: 16px;
				font-weight: 600;
			}

			td:nth-child(1),
			td:nth-child(2) {
				padding: 10px;
				background: var(--white-color);
				text-align: center;
				font-size: 12px;
				font-weight: 600;
			}

			tr:last-child {
				td {
					border-bottom: none;
				}

				td:nth-child(1),
				td:nth-child(2) {
					background: var(--f5-background);
				}
			}

			.events_BcZKK {
				background: var(--f5-background);
				display: inline-flex;
				flex-direction: column;
				gap: 2px;
				width: 100%;
				padding: 10px;

				.item_lW2cp {
					display: flex;
					flex-direction: column;
					gap: 2px;
					border: 1px solid var(--border-color);
					padding: 6px;
				}

				strong {
					font-size: 10px;
					text-transform: uppercase;
					line-height: 2px;
					margin-top: 7px;
				}

			}
		}

		&.timeLine_aGxJM {
			min-width: 750px;
			thead {
				th:nth-child(1) {
					font-size: 14px;
					font-weight: 500;
					padding: 4px 10px;
					font-size: 23px;
					font-weight: 600;
				}

				th {
					background: var(--_16c0982e-background);
					color: var(--_10a37f-background);
					border-color: var(--_16c0982e-background);
					font-size: 12px;
					font-weight: 600;
					padding: 6px;
				}

				tr:nth-child(1) {
					th {
						padding: 2px 9px;
						font-size: 15px;
						font-weight: 600;
						background: var(--white-color);
						border-color: var(--border-color);
					}
				}
			}

			td:nth-child(1) {
				min-width: 230px;
				width: 230px;
				padding: 10px;
				font-size: 14px;
				font-weight: 600;
				background: var(--_16c0982e-background);
				color: var(--_10a37f-background);
				border-color: var(--_16c0982e-background);
				text-align: left;
			}
		}
	}
}

.preview_psEZa {
	display: inline-flex;
	justify-content: center;
	height: 100%;
	width: 100%;
	.left_Av_1k {
		display: inline-flex;
		flex-direction: column;
		gap: 14px;
		min-width: 240px;
		width: 240px;
		padding: 20px 10px;
		overflow-y: scroll;
		background: var(--white-color);
		border: 1px solid var(--border-color);
		overflow-x: hidden;
		&::-webkit-scrollbar {
			display: none;
		}
		.title_okJFn {
			display: inline-flex;
			flex-direction: column;
			gap: 2px;
			align-items: flex-end;
			input {
				width: 100%;
				background: var(--f5-background);
				border: 1px solid var(--border-color);
				padding: 6px 9px;
				border-radius: 4px;
				font-size: 18px;
				font-family: inherit;
			}
			span {
				font-size: 14px;
				color: var(--text-color-secondary);
			}
		}
		.options_tj_DP {
			b {
				font-size: 16px;
				font-weight: 700;
			}
			ul {
				flex-direction: column;
				display: inline-flex;
				align-items: flex-start;
				gap: 8px;
				width: 100%;
				margin: 10px 0px;
				li {
					display: inline-flex;
					align-items: center;
					gap: 12px;
					font-size: 14px;
					font-weight: 500;
					input {
						width: 20px;
						height: 20px;
						border-radius: 4px;
						border: 1px solid var(--border-color);
					}
				}
			}
		}
		.color_o4Qel {
			b {
			}
			ul {
				width: 100%;
				margin: 10px 0px;
				display: grid;
				grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
				li {
					width: 30px;
					height: 30px;
					display: inline-flex;
					align-items: center;
					justify-content: center;
					.color_o4Qel {
						min-width: 20px;
						min-height: 20px;
						border-radius: 50%;
						background: var(--border-color);
						position: relative;
						span {
							display: none;
						}
					}
				}
			}
		}
		.border_MDFHj {
			display: inline-flex;
			align-items: center;
			gap: 6px;
			input {
				width: 20px;
				height: 20px;
				border-radius: 4px;
				border: 1px solid var(--border-color);
			}
		}
		.form_opFh5 {
			ul {
				display: inline-flex;
				flex-direction: column;
				gap: 6px;
				width: 100%;
				li {
					display: flex;
					flex-direction: column;
					gap: 2px;
					position: relative;
					border: 1px solid var(--border-color);
					background: var(--white-color);
					padding: 2px 6px;

					label {
						font-size: 12px;
					}
					span {
						font-size: 15px;
					}
					svg {
						position: absolute;
						top: 10px;
						right: 0px;
						min-width: 20px;
						min-height: 20px;
						width: 20px;
						height: 20px;
					}
					ul {
						display: none;
						width: 100%;
						position: absolute;
						top: 0px;
						left: 0px;
						background: var(--white-color);
						li {
						}
					}
				}
			}
		}
		.shows_tpzPB {
			b {
				font-size: 16px;
				font-weight: 700;
			}
		}
	}
	.right_Apj4d {
		padding: 20px;
		display: inline-flex;
		width: 100%;
		flex-direction: column;
		gap: 10px;
		overflow-y: scroll;
		.input_jfwDP {
			display: inline-flex;
			flex-direction: column;
			gap: 2px;
			position: relative;
			background: var(--white-color);
			padding: 7px;
			border: 1px solid var(--border-color);
			border-radius: 4px;
			label {
				font-size: 12px;
			}
			input {
				font-size: 14px;
			}
			svg {
				position: absolute;
				min-width: 14px;
				min-height: 14px;
				right: 0px;
				top: 0px;
			}
		}
		small {
		}
		.preview_psEZa {
			display: inline-flex;
			flex-direction: column;
			gap: 2px;
			.header_E6dxw {
				display: flex;
				flex-direction: column;
				.title_okJFn {
					display: inline-flex;
					align-items: center;
					gap: 4px;
					justify-content: space-between;
					padding: 4px 10px;
					border-bottom: 1px solid var(--border-color);
					font-size: 18px;
					font-weight: 600;
				}
				> div {
					display: inline-flex;
					align-items: center;
					gap: 4px;
					justify-content: space-between;
					padding: 4px 10px;
					> div {
						display: inline-flex;
						align-items: center;
						gap: 4px;
					}
					.buttonsNavs_xx_4i {
						display: inline-flex;
						align-items: center;
						gap: 4px;
						button {
							width: 25px;
							height: 25px;
							display: inline-flex;
							align-items: center;
							justify-content: center;
							border: 1px solid var(--border-color);
							svg {
								width: 16px;
								color: var(--_10a37f-background);
							}
						}
					}
					.buttons_QES1T {
						display: inline-flex;
						gap: 4px;
						align-items: center;
						button {
							padding: 3px 10px;
							border-radius: 3px;
							border: none;
							outline: none;
							font-size: 12px;
							font-weight: 600;
							font-family: inherit;
							cursor: pointer;
							background: var(--_16c0982e-background);
							color: var(--_10a37f-background);
							&:hover {
								background: var(--_16c0982e-background);
							}
						}
					}
				}
			}
			.calendar_sy1QJ {
				background: var(--white-color);
			}
			.footer_wRvjM {
				display: inline-flex;
				align-items: center;
				padding: 9px;
				gap: 12px;
				p {
					font-size: 12px;
					font-weight: 500;
				}
				div {
					display: flex;
					align-items: center;
				}
			}
		}
	}
}

[class^='calendarMonth'] {
	td {
		height: calc((100vh / 5) - 70px);
	}
}

.date_zYe3g {
	display: flex;
	align-items: center;
	margin-right: 5px;
	justify-content: space-between;
	b {
		font-size: 12px;
		font-weight: 600;
	}
	div {
		display: flex;
		align-items: center;
		gap: 5px;

		button {
			display: flex;
			align-items: center;
			justify-content: center;
			transition:
				background 0.2s ease-in-out,
				transform 0.1s ease-in-out;
			cursor: pointer;
			-webkit-user-select: none;
			        user-select: none;

			width: 25px;
			height: 25px;
			background: var(--_16c0982e-background);
			color: var(--_10a37f-background);
			border-radius: 4px;
			&:hover {
				background: var(--_16c0982e-background);
				transform: scale(1.05);
			}

			&:active {
				background: var(--_16c098-color);
				transform: scale(0.95);
			}
			svg {
				width: 11px;
				height: 11px;
			}
		}
	}
}

.toDay_y0zmX {
	border: 1px solid var(--_16c0982e-background);
	border-radius: 4px;
	width: 40px;
	min-width: 40px;
	height: 25px;
	min-height: 25px;
	cursor: pointer;
	font-family: inherit;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	margin-right: 5px;
}
.actualToday_CnnVQ {
	background: var(--_16c098-background);
	border: none;
	cursor: pointer;
	font-family: inherit;
	color: var(--white-color);
	width: 40px;
	min-width: 40px;
	height: 25px;
	min-height: 25px;
	border: 1px solid var(--_16c098-background);
	width: max-content;
	border-radius: 4px;
	font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/WatchCalendar/WatchCalendar.module.css"],"names":[],"mappings":"AAAA;CACC,oBAAoB;CACpB,sBAAsB;CACtB,QAAQ;CACR,WAAW;CACX;EACC,8BAA8B;EAC9B,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ;GACC,oBAAoB;GACpB,sBAAsB;GACtB,QAAQ;GACR;IACC,eAAe;IACf,gBAAgB;GACjB;GACA;IACC,eAAe;IACf,0BAA0B;IAC1B,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;GACnB;EACD;EACA;GACC,oBAAoB;GACpB,mBAAmB;GACnB,qCAAqC;GACrC,kCAAkC;GAClC,eAAe;GACf,gBAAgB;GAChB,iBAAiB;GACjB,kBAAkB;GAClB,QAAQ;GACR;IACC,kCAAkC;IAClC,WAAW;GACZ;EACD;CACD;CACA;EACC,oBAAoB;EACpB,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB;GACC,gBAAgB;GAChB,YAAY;GACZ,oBAAoB;GACpB,QAAQ;GACR;IACC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,kCAAkC;IAClC,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;GACjB;GACA;IACC,eAAe;IACf,gBAAgB;IAChB,2BAA2B;GAC5B;EACD;EACA;GACC,YAAY;GACZ,oBAAoB;GACpB,sBAAsB;GACtB,uBAAuB;GACvB;IACC,eAAe;IACf,gBAAgB;GACjB;GACA;IACC,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;IACR;KACC,oBAAoB;KACpB,mBAAmB;KACnB,QAAQ;KACR;MACC,WAAW;MACX,YAAY;MACZ,eAAe;MACf,gBAAgB;MAChB,gCAAgC;KACjC;IACD;GACD;EACD;CACD;CACA;EACC,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yCAAyC;EACzC,8BAA8B;EAC9B;GACC,gBAAgB;GAChB,YAAY;GACZ,oBAAoB;GACpB,sBAAsB;GACtB,QAAQ;GACR;IACC,eAAe;GAChB;GACA;IACC,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,8BAA8B;IAC9B;KACC,oBAAoB;KACpB,mBAAmB;KACnB,QAAQ;KACR;MACC,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,qCAAqC;MACrC,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB;OACC,WAAW;MACZ;KACD;IACD;GACD;EACD;CACD;AACD;AACA;CACC,WAAW;CACX,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;CACZ,mBAAmB;CACnB;EACC,WAAW;EACX;;GAEC,sBAAsB;GACtB,kBAAkB;GAClB,eAAe;GACf,YAAY;EACb;CACD;AACD;AACA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,WAAW;CACX,sCAAsC;CACtC,2BAA2B;CAC3B,gBAAgB;CAChB;EACC,WAAW;;EAEX;GACC,gBAAgB;GAChB,iBAAiB;EAClB;;EAEA;GACC,qCAAqC;GACrC,kBAAkB;GAClB,oCAAoC;;GAEpC;IACC,uCAAuC;IACvC,kCAAkC;IAClC,2BAA2B;IAC3B,eAAe;;IAEf;KACC,oCAAoC;KACpC,yCAAyC;KACzC,kCAAkC;IACnC;GACD;EACD;;EAEA;GACC,gBAAgB;GAChB;;IAEC,SAAS;IACT,gBAAgB;IAChB,YAAY;GACb;;GAEA;;IAEC,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;GAClB;;GAEA;IACC,uCAAuC;IACvC,gCAAgC;IAChC,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;GACjB;;GAEA;IACC,gCAAgC;GACjC;;GAEA;;IAEC,WAAW;GACZ;EACD;;EAEA;GACC,gBAAgB;GAChB;;IAEC,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;GACb;GACA;IACC,sCAAsC;GACvC;GACA;;IAEC,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;GAClB;;GAEA;IACC,uCAAuC;IACvC,gCAAgC;IAChC,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;GACjB;;GAEA;IACC,gCAAgC;GACjC;EACD;;EAEA;GACC,gBAAgB;GAChB;;IAEC,qBAAqB;GACtB;;GAEA;IACC,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,yCAAyC;IACzC,eAAe;IACf,gBAAgB;GACjB;;GAEA;IACC,gBAAgB;IAChB,gCAAgC;;IAEhC;KACC,oBAAoB;KACpB,sBAAsB;KACtB,kBAAkB;KAClB,mBAAmB;KACnB,2BAA2B;KAC3B,YAAY;KACZ,iBAAiB;KACjB,WAAW;;KAEX;MACC,eAAe;MACf,gBAAgB;KACjB;;KAEA;MACC,eAAe;MACf,oBAAoB;MACpB,sBAAsB;;MAEtB;OACC,cAAc;OACd,oBAAoB;OACpB,sBAAsB;OACtB,mBAAmB;OACnB,QAAQ;;OAER;QACC,oBAAoB;QACpB,mBAAmB;QACnB,QAAQ;;QAER;SACC,cAAc;SACd,eAAe;SACf,kBAAkB;SAClB,uCAAuC;;SAEvC;UACC,qCAAqC;SACtC;QACD;;QAEA;SACC,eAAe;SACf,gBAAgB;QACjB;OACD;;OAEA;QACC,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,8BAA8B;QAC9B,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf;SACC,aAAa;QACd;QACA;SACC,gCAAgC;QACjC;;QAEA;SACC,eAAe;SACf,gBAAgB;QACjB;;QAEA;SACC,YAAY;SACZ,eAAe;SACf,gBAAgB;QACjB;OACD;MACD;KACD;IACD;GACD;EACD;;EAEA;GACC,gBAAgB;GAChB;IACC,yCAAyC;IACzC,uCAAuC;IACvC,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;GACjB;;GAEA;;IAEC,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;GACjB;;GAEA;IACC;KACC,mBAAmB;IACpB;;IAEA;;KAEC,gCAAgC;IACjC;GACD;;GAEA;IACC,gCAAgC;IAChC,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX,aAAa;;IAEb;KACC,aAAa;KACb,sBAAsB;KACtB,QAAQ;KACR,qCAAqC;KACrC,YAAY;IACb;;IAEA;KACC,eAAe;KACf,yBAAyB;KACzB,gBAAgB;KAChB,eAAe;IAChB;;GAED;EACD;;EAEA;GACC,gBAAgB;GAChB;IACC;KACC,eAAe;KACf,gBAAgB;KAChB,iBAAiB;KACjB,eAAe;KACf,gBAAgB;IACjB;;IAEA;KACC,uCAAuC;KACvC,gCAAgC;KAChC,yCAAyC;KACzC,eAAe;KACf,gBAAgB;KAChB,YAAY;IACb;;IAEA;KACC;MACC,gBAAgB;MAChB,eAAe;MACf,gBAAgB;MAChB,8BAA8B;MAC9B,iCAAiC;KAClC;IACD;GACD;;GAEA;IACC,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,gCAAgC;IAChC,yCAAyC;IACzC,gBAAgB;GACjB;EACD;CACD;AACD;;AAEA;CACC,oBAAoB;CACpB,uBAAuB;CACvB,YAAY;CACZ,WAAW;CACX;EACC,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB;GACC,aAAa;EACd;EACA;GACC,oBAAoB;GACpB,sBAAsB;GACtB,QAAQ;GACR,qBAAqB;GACrB;IACC,WAAW;IACX,gCAAgC;IAChC,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;GACrB;GACA;IACC,eAAe;IACf,kCAAkC;GACnC;EACD;EACA;GACC;IACC,eAAe;IACf,gBAAgB;GACjB;GACA;IACC,sBAAsB;IACtB,oBAAoB;IACpB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB;KACC,oBAAoB;KACpB,mBAAmB;KACnB,SAAS;KACT,eAAe;KACf,gBAAgB;KAChB;MACC,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,qCAAqC;KACtC;IACD;GACD;EACD;EACA;GACC;GACA;GACA;IACC,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kDAAkD;IAClD;KACC,WAAW;KACX,YAAY;KACZ,oBAAoB;KACpB,mBAAmB;KACnB,uBAAuB;KACvB;MACC,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,+BAA+B;MAC/B,kBAAkB;MAClB;OACC,aAAa;MACd;KACD;IACD;GACD;EACD;EACA;GACC,oBAAoB;GACpB,mBAAmB;GACnB,QAAQ;GACR;IACC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;GACtC;EACD;EACA;GACC;IACC,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX;KACC,aAAa;KACb,sBAAsB;KACtB,QAAQ;KACR,kBAAkB;KAClB,qCAAqC;KACrC,8BAA8B;KAC9B,gBAAgB;;KAEhB;MACC,eAAe;KAChB;KACA;MACC,eAAe;KAChB;KACA;MACC,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,eAAe;MACf,gBAAgB;MAChB,WAAW;MACX,YAAY;KACb;KACA;MACC,aAAa;MACb,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,8BAA8B;MAC9B;MACA;KACD;IACD;GACD;EACD;EACA;GACC;IACC,eAAe;IACf,gBAAgB;GACjB;EACD;CACD;CACA;EACC,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB;GACC,oBAAoB;GACpB,sBAAsB;GACtB,QAAQ;GACR,kBAAkB;GAClB,8BAA8B;GAC9B,YAAY;GACZ,qCAAqC;GACrC,kBAAkB;GAClB;IACC,eAAe;GAChB;GACA;IACC,eAAe;GAChB;GACA;IACC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,QAAQ;GACT;EACD;EACA;EACA;EACA;GACC,oBAAoB;GACpB,sBAAsB;GACtB,QAAQ;GACR;IACC,aAAa;IACb,sBAAsB;IACtB;KACC,oBAAoB;KACpB,mBAAmB;KACnB,QAAQ;KACR,8BAA8B;KAC9B,iBAAiB;KACjB,4CAA4C;KAC5C,eAAe;KACf,gBAAgB;IACjB;IACA;KACC,oBAAoB;KACpB,mBAAmB;KACnB,QAAQ;KACR,8BAA8B;KAC9B,iBAAiB;KACjB;MACC,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ;KACT;KACA;MACC,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ;MACR;OACC,WAAW;OACX,YAAY;OACZ,oBAAoB;OACpB,mBAAmB;OACnB,uBAAuB;OACvB,qCAAqC;OACrC;QACC,WAAW;QACX,gCAAgC;OACjC;MACD;KACD;KACA;MACC,oBAAoB;MACpB,QAAQ;MACR,mBAAmB;MACnB;OACC,iBAAiB;OACjB,kBAAkB;OAClB,YAAY;OACZ,aAAa;OACb,eAAe;OACf,gBAAgB;OAChB,oBAAoB;OACpB,eAAe;OACf,uCAAuC;OACvC,gCAAgC;OAChC;QACC,uCAAuC;OACxC;MACD;KACD;IACD;GACD;GACA;IACC,8BAA8B;GAC/B;GACA;IACC,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT;KACC,eAAe;KACf,gBAAgB;IACjB;IACA;KACC,aAAa;KACb,mBAAmB;IACpB;GACD;EACD;CACD;AACD;;AAEA;CACC;EACC,gCAAgC;CACjC;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,iBAAiB;CACjB,8BAA8B;CAC9B;EACC,eAAe;EACf,gBAAgB;CACjB;CACA;EACC,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER;GACC,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB;;8BAE2B;GAC3B,eAAe;GACf,yBAAiB;WAAjB,iBAAiB;;GAEjB,WAAW;GACX,YAAY;GACZ,uCAAuC;GACvC,gCAAgC;GAChC,kBAAkB;GAClB;IACC,uCAAuC;IACvC,sBAAsB;GACvB;;GAEA;IACC,gCAAgC;IAChC,sBAAsB;GACvB;GACA;IACC,WAAW;IACX,YAAY;GACb;EACD;CACD;AACD;;AAEA;CACC,6CAA6C;CAC7C,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,qCAAqC;CACrC,YAAY;CACZ,eAAe;CACf,oBAAoB;CACpB,yBAAyB;CACzB,WAAW;CACX,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,2CAA2C;CAC3C,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;AAChB","sourcesContent":[".container {\n\tdisplay: inline-flex;\n\tflex-direction: column;\n\tgap: 6px;\n\twidth: 100%;\n\t.header {\n\t\tbackground: var(--white-color);\n\t\tborder: 1px solid var(--border-color);\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\twidth: 100%;\n\t\tpadding: 8px;\n\t\t.title {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 2px;\n\t\t\tp {\n\t\t\t\tfont-size: 18px;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t\ta {\n\t\t\t\tfont-size: 14px;\n\t\t\t\ttext-decoration: underline;\n\t\t\t\tcolor: var(--text-color-secondary);\n\t\t\t\tline-height: 7px;\n\t\t\t\tmargin-bottom: 8px;\n\t\t\t}\n\t\t}\n\t\t.share {\n\t\t\tdisplay: inline-flex;\n\t\t\talign-items: center;\n\t\t\tbackground: var(--_10a37f-background);\n\t\t\tcolor: var(--_16c0982e-background);\n\t\t\tfont-size: 16px;\n\t\t\tfont-weight: 600;\n\t\t\tpadding: 4px 10px;\n\t\t\tborder-radius: 6px;\n\t\t\tgap: 8px;\n\t\t\tsvg {\n\t\t\t\tcolor: var(--_16c0982e-background);\n\t\t\t\twidth: 14px;\n\t\t\t}\n\t\t}\n\t}\n\t.subHeader {\n\t\tdisplay: inline-flex;\n\t\tgap: 40px;\n\t\talign-items: flex-start;\n\t\tpadding: 4px 10px 8px;\n\t\t.left {\n\t\t\tmin-width: 310px;\n\t\t\twidth: 310px;\n\t\t\tdisplay: inline-flex;\n\t\t\tgap: 8px;\n\t\t\t> div {\n\t\t\t\tmin-width: 40px;\n\t\t\t\tmin-height: 40px;\n\t\t\t\twidth: 40px;\n\t\t\t\theight: 40px;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tbackground: var(--_10a37f-background);\n\t\t\t\tcolor: var(--_16c0982e-background);\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tfont-size: 23px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 0px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tfont-size: 26px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: var(--_3c3a3a-color);\n\t\t\t}\n\t\t}\n\t\t.right {\n\t\t\twidth: 600px;\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: flex-start;\n\t\t\tb {\n\t\t\t\tfont-size: 22px;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t\tul {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 2px;\n\t\t\t\tli {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 4px;\n\t\t\t\t\tsvg {\n\t\t\t\t\t\twidth: 20px;\n\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t\tmin-width: 20px;\n\t\t\t\t\t\tmin-height: 20px;\n\t\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.calendar {\n\t\tdisplay: inline-flex;\n\t\talign-items: flex-start;\n\t\tgap: 10px;\n\t\tpadding: 10px;\n\t\tborder-top: 1px solid var(--border-color);\n\t\tbackground: var(--white-color);\n\t\t.left {\n\t\t\tmin-width: 280px;\n\t\t\twidth: 280px;\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 6px;\n\t\t\t.title {\n\t\t\t\tfont-size: 26px;\n\t\t\t}\n\t\t\t.date {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 2px;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t> div {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 4px;\n\t\t\t\t\tbutton {\n\t\t\t\t\t\tmin-width: 20px;\n\t\t\t\t\t\tmin-height: 20px;\n\t\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\tsvg {\n\t\t\t\t\t\t\twidth: 12px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.miniCalendar {\n\twidth: 100%;\n\tbackground: transparent;\n\tborder-radius: 10px;\n\tpadding: 4px;\n\tpadding-bottom: 6px;\n\ttable {\n\t\twidth: 100%;\n\t\ttd,\n\t\tth {\n\t\t\twidth: calc(100vh / 7);\n\t\t\ttext-align: center;\n\t\t\tfont-size: 12px;\n\t\t\theight: 40px;\n\t\t}\n\t}\n}\n.liText {\n\tfont-size: 12px;\n}\n\n.tableCalendar {\n\tborder-radius: 8px;\n\tz-index: 5000;\n\twidth: 100%;\n\tbackground-color: var(--f5-background);\n\theight: calc(100vh - 112px);\n\toverflow: scroll;\n\ttable {\n\t\twidth: 100%;\n\n\t\tth {\n\t\t\ttext-align: left;\n\t\t\tmin-height: 100px;\n\t\t}\n\n\t\ttd {\n\t\t\tborder: 1px solid var(--border-color);\n\t\t\ttext-align: center;\n\t\t\tbackground-color: var(--white-color);\n\n\t\t\t&.active {\n\t\t\t\tbackground: var(--_16c09821-background);\n\t\t\t\tborder-color: var(--_16c098-color);\n\t\t\t\tcolor: var(--_16c098-color);\n\t\t\t\tcursor: pointer;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--e6fff9-background);\n\t\t\t\t\tborder-color: var(--_16c09821-background);\n\t\t\t\t\tcolor: var(--_16c09821-background);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.calendarDay {\n\t\t\tmin-width: 750px;\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\twidth: 7%;\n\t\t\t\tmin-height: 40px;\n\t\t\t\theight: 40px;\n\t\t\t}\n\n\t\t\tth:nth-child(1),\n\t\t\ttd:nth-child(1) {\n\t\t\t\tposition: relative;\n\t\t\t\tmin-width: 70px;\n\t\t\t\twidth: 70px;\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder-color: var(--border-color);\n\t\t\t\tborder-left: none !important;\n\t\t\t\tborder-right: none !important;\n\t\t\t\tpadding: 2px 5px;\n\t\t\t\tfont-size: 11px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\ttext-align: right;\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder-color: var(--_16c0982e-background);\n\t\t\t\tpadding: 2px 9px;\n\t\t\t\tfont-size: 15px;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\n\t\t\tth:nth-child(1) {\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t}\n\n\t\t\tth:nth-child(2),\n\t\t\ttd:nth-child(2) {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&.calendarWeek {\n\t\t\tmin-width: 750px;\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\twidth: 11vw !important;\n\t\t\t\tmin-height: 40px;\n\t\t\t\theight: 40px;\n\t\t\t}\n\t\t\ttbody {\n\t\t\t\tbackground-color: var(--f5-background);\n\t\t\t}\n\t\t\tth:nth-child(1),\n\t\t\ttd:nth-child(1) {\n\t\t\t\tposition: relative;\n\t\t\t\tmin-width: 70px;\n\t\t\t\twidth: 70px !important;\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder-color: var(--border-color);\n\t\t\t\tborder-left: none !important;\n\t\t\t\tborder-right: none !important;\n\t\t\t\tpadding: 2px 5px;\n\t\t\t\tfont-size: 11px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\ttext-align: right;\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder-color: var(--_16c0982e-background);\n\t\t\t\tpadding: 2px 9px;\n\t\t\t\tfont-size: 15px;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\n\t\t\tth:nth-child(1) {\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t}\n\t\t}\n\n\t\t&.calendarMonth {\n\t\t\tmin-width: 750px;\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\twidth: calc(100% / 7);\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\ttext-align: center;\n\t\t\t\tborder-bottom: none;\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder-color: var(--_16c0982e-background);\n\t\t\t\tfont-size: 11px;\n\t\t\t\tpadding-top: 2px;\n\t\t\t}\n\n\t\t\ttd {\n\t\t\t\tborder-top: none;\n\t\t\t\theight: calc((100vh / 5) - 26px);\n\n\t\t\t\t.day {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tmax-height: 175px;\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\tb {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tfont-weight: 800;\n\t\t\t\t\t}\n\n\t\t\t\t\tul {\n\t\t\t\t\t\tmargin-top: 4px;\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\tflex-direction: column;\n\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tgap: 4px;\n\n\t\t\t\t\t\t\t.date {\n\t\t\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\tgap: 4px;\n\n\t\t\t\t\t\t\t\t.dot {\n\t\t\t\t\t\t\t\t\tmin-width: 8px;\n\t\t\t\t\t\t\t\t\tmin-height: 8px;\n\t\t\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t\t\t\tbackground: var(--_16c0982e-background);\n\n\t\t\t\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t\t\t\tbackground: var(--_10a37f-background);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.info {\n\t\t\t\t\t\t\t\twidth: 80px;\n\t\t\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t\t\tbackground: var(--white-color);\n\t\t\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\t\t\tpadding: 2px 4px;\n\t\t\t\t\t\t\t\ttext-wrap: nowrap;\n\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\t&::-webkit-scrollbar {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tbackground: var(--f5-background);\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\tb {\n\t\t\t\t\t\t\t\t\twidth: 100px;\n\t\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.schedule {\n\t\t\tmin-width: 750px;\n\t\t\tth {\n\t\t\t\tborder-color: var(--_16c0982e-background);\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tpadding: 4px 10px;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\n\t\t\ttd:nth-child(1),\n\t\t\ttd:nth-child(2) {\n\t\t\t\tpadding: 10px;\n\t\t\t\tbackground: var(--white-color);\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-size: 12px;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\n\t\t\ttr:last-child {\n\t\t\t\ttd {\n\t\t\t\t\tborder-bottom: none;\n\t\t\t\t}\n\n\t\t\t\ttd:nth-child(1),\n\t\t\t\ttd:nth-child(2) {\n\t\t\t\t\tbackground: var(--f5-background);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.events {\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 2px;\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding: 10px;\n\n\t\t\t\t.item {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tgap: 2px;\n\t\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\t\tpadding: 6px;\n\t\t\t\t}\n\n\t\t\t\tstrong {\n\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tline-height: 2px;\n\t\t\t\t\tmargin-top: 7px;\n\t\t\t\t}\n\n\t\t\t}\n\t\t}\n\n\t\t&.timeLine {\n\t\t\tmin-width: 750px;\n\t\t\tthead {\n\t\t\t\tth:nth-child(1) {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tpadding: 4px 10px;\n\t\t\t\t\tfont-size: 23px;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t}\n\n\t\t\t\tth {\n\t\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\tborder-color: var(--_16c0982e-background);\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tpadding: 6px;\n\t\t\t\t}\n\n\t\t\t\ttr:nth-child(1) {\n\t\t\t\t\tth {\n\t\t\t\t\t\tpadding: 2px 9px;\n\t\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\tbackground: var(--white-color);\n\t\t\t\t\t\tborder-color: var(--border-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\ttd:nth-child(1) {\n\t\t\t\tmin-width: 230px;\n\t\t\t\twidth: 230px;\n\t\t\t\tpadding: 10px;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder-color: var(--_16c0982e-background);\n\t\t\t\ttext-align: left;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.preview {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\theight: 100%;\n\twidth: 100%;\n\t.left {\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\tgap: 14px;\n\t\tmin-width: 240px;\n\t\twidth: 240px;\n\t\tpadding: 20px 10px;\n\t\toverflow-y: scroll;\n\t\tbackground: var(--white-color);\n\t\tborder: 1px solid var(--border-color);\n\t\toverflow-x: hidden;\n\t\t&::-webkit-scrollbar {\n\t\t\tdisplay: none;\n\t\t}\n\t\t.title {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 2px;\n\t\t\talign-items: flex-end;\n\t\t\tinput {\n\t\t\t\twidth: 100%;\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\tpadding: 6px 9px;\n\t\t\t\tborder-radius: 4px;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tfont-family: inherit;\n\t\t\t}\n\t\t\tspan {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: var(--text-color-secondary);\n\t\t\t}\n\t\t}\n\t\t.options {\n\t\t\tb {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t\tul {\n\t\t\t\tflex-direction: column;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tgap: 8px;\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin: 10px 0px;\n\t\t\t\tli {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 12px;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tinput {\n\t\t\t\t\t\twidth: 20px;\n\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.color {\n\t\t\tb {\n\t\t\t}\n\t\t\tul {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin: 10px 0px;\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;\n\t\t\t\tli {\n\t\t\t\t\twidth: 30px;\n\t\t\t\t\theight: 30px;\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t.color {\n\t\t\t\t\t\tmin-width: 20px;\n\t\t\t\t\t\tmin-height: 20px;\n\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\tbackground: var(--border-color);\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.border {\n\t\t\tdisplay: inline-flex;\n\t\t\talign-items: center;\n\t\t\tgap: 6px;\n\t\t\tinput {\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t\tborder-radius: 4px;\n\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t}\n\t\t}\n\t\t.form {\n\t\t\tul {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 6px;\n\t\t\t\twidth: 100%;\n\t\t\t\tli {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tgap: 2px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\t\tbackground: var(--white-color);\n\t\t\t\t\tpadding: 2px 6px;\n\n\t\t\t\t\tlabel {\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t}\n\t\t\t\t\tspan {\n\t\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\t}\n\t\t\t\t\tsvg {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 10px;\n\t\t\t\t\t\tright: 0px;\n\t\t\t\t\t\tmin-width: 20px;\n\t\t\t\t\t\tmin-height: 20px;\n\t\t\t\t\t\twidth: 20px;\n\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t}\n\t\t\t\t\tul {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 0px;\n\t\t\t\t\t\tleft: 0px;\n\t\t\t\t\t\tbackground: var(--white-color);\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.shows {\n\t\t\tb {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n\t.right {\n\t\tpadding: 20px;\n\t\tdisplay: inline-flex;\n\t\twidth: 100%;\n\t\tflex-direction: column;\n\t\tgap: 10px;\n\t\toverflow-y: scroll;\n\t\t.input {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 2px;\n\t\t\tposition: relative;\n\t\t\tbackground: var(--white-color);\n\t\t\tpadding: 7px;\n\t\t\tborder: 1px solid var(--border-color);\n\t\t\tborder-radius: 4px;\n\t\t\tlabel {\n\t\t\t\tfont-size: 12px;\n\t\t\t}\n\t\t\tinput {\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t\tsvg {\n\t\t\t\tposition: absolute;\n\t\t\t\tmin-width: 14px;\n\t\t\t\tmin-height: 14px;\n\t\t\t\tright: 0px;\n\t\t\t\ttop: 0px;\n\t\t\t}\n\t\t}\n\t\tsmall {\n\t\t}\n\t\t.preview {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 2px;\n\t\t\t.header {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\t.title {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 4px;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\tpadding: 4px 10px;\n\t\t\t\t\tborder-bottom: 1px solid var(--border-color);\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t}\n\t\t\t\t> div {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 4px;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\tpadding: 4px 10px;\n\t\t\t\t\t> div {\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tgap: 4px;\n\t\t\t\t\t}\n\t\t\t\t\t.buttonsNavs {\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tgap: 4px;\n\t\t\t\t\t\tbutton {\n\t\t\t\t\t\t\twidth: 25px;\n\t\t\t\t\t\t\theight: 25px;\n\t\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\t\t\t\tsvg {\n\t\t\t\t\t\t\t\twidth: 16px;\n\t\t\t\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.buttons {\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\tgap: 4px;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tbutton {\n\t\t\t\t\t\t\tpadding: 3px 10px;\n\t\t\t\t\t\t\tborder-radius: 3px;\n\t\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\toutline: none;\n\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t\tfont-family: inherit;\n\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.calendar {\n\t\t\t\tbackground: var(--white-color);\n\t\t\t}\n\t\t\t.footer {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\talign-items: center;\n\t\t\t\tpadding: 9px;\n\t\t\t\tgap: 12px;\n\t\t\t\tp {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t}\n\t\t\t\tdiv {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n[class^='calendarMonth'] {\n\ttd {\n\t\theight: calc((100vh / 5) - 70px);\n\t}\n}\n\n.date {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-right: 5px;\n\tjustify-content: space-between;\n\tb {\n\t\tfont-size: 12px;\n\t\tfont-weight: 600;\n\t}\n\tdiv {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 5px;\n\n\t\tbutton {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\ttransition:\n\t\t\t\tbackground 0.2s ease-in-out,\n\t\t\t\ttransform 0.1s ease-in-out;\n\t\t\tcursor: pointer;\n\t\t\tuser-select: none;\n\n\t\t\twidth: 25px;\n\t\t\theight: 25px;\n\t\t\tbackground: var(--_16c0982e-background);\n\t\t\tcolor: var(--_10a37f-background);\n\t\t\tborder-radius: 4px;\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\ttransform: scale(1.05);\n\t\t\t}\n\n\t\t\t&:active {\n\t\t\t\tbackground: var(--_16c098-color);\n\t\t\t\ttransform: scale(0.95);\n\t\t\t}\n\t\t\tsvg {\n\t\t\t\twidth: 11px;\n\t\t\t\theight: 11px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.toDay {\n\tborder: 1px solid var(--_16c0982e-background);\n\tborder-radius: 4px;\n\twidth: 40px;\n\tmin-width: 40px;\n\theight: 25px;\n\tmin-height: 25px;\n\tcursor: pointer;\n\tfont-family: inherit;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 14px;\n\tmargin-right: 5px;\n}\n.actualToday {\n\tbackground: var(--_16c098-background);\n\tborder: none;\n\tcursor: pointer;\n\tfont-family: inherit;\n\tcolor: var(--white-color);\n\twidth: 40px;\n\tmin-width: 40px;\n\theight: 25px;\n\tmin-height: 25px;\n\tborder: 1px solid var(--_16c098-background);\n\twidth: max-content;\n\tborder-radius: 4px;\n\tfont-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_clGHc`,
	"header": `header_E6dxw`,
	"title": `title_okJFn`,
	"share": `share_Ahg_s`,
	"subHeader": `subHeader_J0m7k`,
	"left": `left_Av_1k`,
	"right": `right_Apj4d`,
	"calendar": `calendar_sy1QJ`,
	"date": `date_zYe3g`,
	"miniCalendar": `miniCalendar_mTerZ`,
	"liText": `liText_AFdHM`,
	"tableCalendar": `tableCalendar_j0uT2`,
	"active": `active_YlASi`,
	"calendarDay": `calendarDay_WLldi`,
	"calendarWeek": `calendarWeek__LoKs`,
	"calendarMonth": `calendarMonth_dSM0c`,
	"day": `day_EQoXh`,
	"dot": `dot_Pfcwl`,
	"info": `info_QQsqq`,
	"schedule": `schedule_WLaWf`,
	"events": `events_BcZKK`,
	"item": `item_lW2cp`,
	"timeLine": `timeLine_aGxJM`,
	"preview": `preview_psEZa`,
	"options": `options_tj_DP`,
	"color": `color_o4Qel`,
	"border": `border_MDFHj`,
	"form": `form_opFh5`,
	"shows": `shows_tpzPB`,
	"input": `input_jfwDP`,
	"buttonsNavs": `buttonsNavs_xx_4i`,
	"buttons": `buttons_QES1T`,
	"footer": `footer_wRvjM`,
	"toDay": `toDay_y0zmX`,
	"actualToday": `actualToday_CnnVQ`
};
export default ___CSS_LOADER_EXPORT___;
